import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { formatTimestampToLocalTime } from "utils/formatting";
import "../../index.css";

interface RefetchingStatusProps {
  isRefetching: boolean;
  updatedAtTimestamp: number;
}

const RefetchingStatus: React.FC<RefetchingStatusProps> = ({
  isRefetching,
  updatedAtTimestamp,
}) => {
  const formattedUpdatedAt = formatTimestampToLocalTime(updatedAtTimestamp);

  return (
    <Box>
      <Typography align="right" className="refetching-text">
        {updatedAtTimestamp == 0
          ? "Loading"
          : isRefetching
          ? "Refetching"
          : `Last updated: ${formattedUpdatedAt}`}
        {updatedAtTimestamp == 0 || isRefetching ? (
          <span className="animated-dots">...</span>
        ) : (
          ""
        )}
      </Typography>
    </Box>
  );
};

export default RefetchingStatus;
